import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { PageLayout } from 'coreOld/components';
import { RequestJobsDetails } from 'support/components';

const EditRequestJobsPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t('titleSupportRequestEditJob', { id })}
      hasSubHeader={false}
      hasSearchBar={false}
      collapsedMenu
    >
      <RequestJobsDetails requestId={Number(id)} />
    </PageLayout>
  );
};

export default EditRequestJobsPage;
